import { getApiClient } from './api-client'

export type SavedGame = {
  id?: number
  userId: number
  gameId: string
  title: string
  imageUrl: string
  releaseDate: string
  rating: number
  status: string
  isFavorite: boolean
}

export type LibraryCountResponse = {
  libraryCount: number
}

const baseUrl = '/SavedGame'

const savedGameApi = {
  async getLibrary(userId: number) {
    const apiClient = getApiClient()
    const response = await apiClient.get<SavedGame[]>(`${baseUrl}/User/${userId}`)
    return response.data
  },

  async getLibraryCount(gameId: string) {
    const apiClient = getApiClient()

    const response =
      await apiClient.get<LibraryCountResponse>(
        `${baseUrl}/Count/${gameId}`
      )

    return response.data
  },

  async saveGame(game: SavedGame) {
    const apiClient = getApiClient()
    const response = await apiClient.post<SavedGame>(baseUrl, game)
    return response.data
  },

  async deleteGame(id: number) {
    const apiClient = await getApiClient()
    await apiClient.delete(`${baseUrl}/${id}`)
  },

  async updateStatus(id: number, status: string) {
    const apiClient = getApiClient()
    const response = await apiClient.put<SavedGame>(
      `${baseUrl}/Status/${id}`,
      JSON.stringify(status)
    )
    return response.data
  },

  async updateFavorite(id: number, isFavorite: boolean) {
    const apiClient = getApiClient()
    const response = await apiClient.put<SavedGame>(
      `${baseUrl}/Favorite/${id}`,
      JSON.stringify(isFavorite)
    )
    return response.data
  }
}

export default savedGameApi